import React from 'react'

type Props = {
  fill?: string
  size?: string
} & React.HTMLAttributes<SVGElement>

const CloseCircle = ({ fill = '#677185', size = '34', ...rest }: Props) => (
  <svg
    fill={fill}
    height={size}
    viewBox='0 0 34 34'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
    {...rest}
  >
    <path d='M16.9997 0.333252C7.78301 0.333252 0.333008 7.78325 0.333008 16.9999C0.333008 26.2166 7.78301 33.6666 16.9997 33.6666C26.2163 33.6666 33.6663 26.2166 33.6663 16.9999C33.6663 7.78325 26.2163 0.333252 16.9997 0.333252ZM25.333 22.9833L22.983 25.3333L16.9997 19.3499L11.0163 25.3333L8.66634 22.9833L14.6497 16.9999L8.66634 11.0166L11.0163 8.66658L16.9997 14.6499L22.983 8.66658L25.333 11.0166L19.3497 16.9999L25.333 22.9833Z' />
  </svg>
)

export default CloseCircle
